"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VisualizeButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _lodash = _interopRequireDefault(require("lodash"));
var _reactRouterDom = require("react-router-dom");
var _Link = require("react-platform-components/dist/Link/Link");
var _config = require("../../../config");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    link: {
      all: "unset",
      "&:hover": {
        all: "unset"
      }
    }
  };
});
var VisualizeButton = function VisualizeButton(props) {
  var product = props.product,
    detailEndpoint = props.detailEndpoint,
    children = props.children;
  var classes = useStyles();
  var productDetailsEndpoint = props.productDetailsEndpoint ? props.productDetailsEndpoint(product) : null;
  return !_lodash.default.isEmpty(_config.SHOW_PREVISUALIZE_PRODUCT_STATUS) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, product.status === _config.SHOW_PREVISUALIZE_PRODUCT_STATUS ? _config.REACT_PRODUCT_DETAIL_ENDPOINT ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/".concat(productDetailsEndpoint !== null && productDetailsEndpoint !== void 0 ? productDetailsEndpoint : detailEndpoint, "/").concat(product.id)
  }, children) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
    className: classes.link,
    to: "".concat(productDetailsEndpoint !== null && productDetailsEndpoint !== void 0 ? productDetailsEndpoint : _config.PRODUCT_DETAIL_ENDPOINT, "/").concat(product.id),
    base: _config.BASE_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children) : null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, product.status !== "draft" ? _config.REACT_PRODUCT_DETAIL_ENDPOINT ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/".concat(productDetailsEndpoint !== null && productDetailsEndpoint !== void 0 ? productDetailsEndpoint : detailEndpoint, "/").concat(product.id)
  }, children) : /*#__PURE__*/_react.default.createElement(_Link.Link, {
    className: classes.link,
    to: "".concat(productDetailsEndpoint !== null && productDetailsEndpoint !== void 0 ? productDetailsEndpoint : _config.PRODUCT_DETAIL_ENDPOINT, "/").concat(product.id),
    base: _config.BASE_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children) : null);
};
exports.VisualizeButton = VisualizeButton;